export const modalSize = {
  large: {
    height: '720px',
    minWidth: '1198px'
  }
};